export function Footer() {
  return (
    <footer className="bg-[#1A1A1A] border-t border-[#333333]">
      <div className="container py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-6 sm:gap-8 lg:gap-12">
          {/* Logo & Company - Full width on mobile */}
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#E03030]" />
              <span className="font-bold text-lg text-white" style={{ fontFamily: "'Inter', sans-serif" }}>
                eightone
              </span>
            </div>
            <p className="text-xs sm:text-sm text-[#AAAAAA] leading-relaxed mb-3 sm:mb-4 max-w-sm">
              81合同会社｜DXコンサルタント／共創プロデューサー。
              現場・人・仕組みを一緒に育てる伴走型DXパートナー。
            </p>
            <p className="text-[10px] sm:text-xs text-[#999999]">
              〒541-0046 大阪府大阪市中央区平野町2-3-7
              <br />
              アーバンエース北浜ビル1F SYNTH
            </p>
          </div>

          {/* Service Links */}
          <div className="col-span-1 md:col-span-3">
            <p className="text-[10px] sm:text-xs font-bold text-[#999999] tracking-widest uppercase mb-3 sm:mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Service
            </p>
            <nav className="space-y-2 sm:space-y-2">
              <a href="#services" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                AI業務自動化スターターパック
              </a>
              <a href="#services" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                内製化支援プログラム
              </a>
              <a href="#services" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                業種特化型AIエージェント
              </a>
            </nav>
          </div>

          {/* Company Links */}
          <div className="col-span-1 md:col-span-2">
            <p className="text-[10px] sm:text-xs font-bold text-[#999999] tracking-widest uppercase mb-3 sm:mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Company
            </p>
            <nav className="space-y-2 sm:space-y-2">
              <a href="#company" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                会社概要
              </a>
              <a href="#seminar-section" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                DXセミナー・研修
              </a>
              <a href="#solutions" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                業種別ソリューション
              </a>
              <a href="https://note.com/sotaro_81" target="_blank" rel="noopener noreferrer" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                note（DXのヒント）
              </a>
              <a href="https://eightone.co/" target="_blank" rel="noopener noreferrer" className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                公式サイト
              </a>
              <button onClick={() => { import('@/hooks/useScrollToContact').then(m => m.scrollToContactForm()); }} className="block text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5 text-left">
                お問い合わせ
              </button>
            </nav>
          </div>

          {/* Contact - Full width on mobile */}
          <div className="col-span-2 md:col-span-2">
            <p className="text-[10px] sm:text-xs font-bold text-[#999999] tracking-widest uppercase mb-3 sm:mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact
            </p>
            <div className="flex sm:flex-col gap-4 sm:gap-2">
              <a href="tel:05050521301" className="text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>
                050-5052-1301
              </a>
              <a href="mailto:81@eightone.co" className="text-xs sm:text-sm text-[#AAAAAA] hover:text-[#E03030] transition-colors py-0.5">
                81@eightone.co
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 sm:mt-12 pt-4 sm:pt-6 border-t border-[#333333] flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
          <p className="text-[10px] sm:text-xs text-[#999999]">
            &copy; 2026 81合同会社 All rights reserved.
          </p>
          <p className="text-[10px] sm:text-xs text-[#999999]">
            Powered by Antigravity × Workspace MCP
          </p>
        </div>
      </div>
    </footer>
  );
}
